import { createTheme } from '@mui/material/styles';

import layout from './layout';
import palette from './palette';
import typography from './typography';

type LayoutConfig = typeof layout;

declare module '@mui/material/styles' {
  interface Color {
    150: string;
  }
  interface Theme {
    layout: LayoutConfig;
  }
  interface ThemeOptions {
    layout?: LayoutConfig;
  }
  interface Palette {
    green: Record<number | string, string>;
    orange: Record<number | string, string>;
    blue: Record<number | string, string>;
    red: Record<number | string, string>;
    violet: Record<number | string, string>;
    pink?: Record<number | string, string>;
  }
  interface PaletteOptions {
    green: Record<number | string, string>;
    orange: Record<number | string, string>;
    blue?: Record<number | string, string>;
    violet?: Record<number | string, string>;
    pink?: Record<number | string, string>;
  }
}

declare module '@mui/material/IconButton' {
  interface IconButtonPropsColorOverrides {
    green: true;
    orange: true;
    violet: true;
    pink: true;
    grey: true;
  }
}

const baseTheme = createTheme({
  palette,
  typography,
  layout,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1440,
    },
  },
  shape: {
    borderRadius: 3,
  },
});

export default baseTheme;
